import React from 'react';
import {Box, Stack, Typography, Button} from '@mui/material'
import { FiberManualRecord } from '@mui/icons-material';

export const Verified = () => {
  return (
    <Box>
      <Stack
        sx={{
          position: "absolute",
          top: "30%",
          alignItems: "center",
          justifyContent: "center",
          width: '100%'
        }}
        spacing={5}
      >
        <img src="/images/verified.svg" alt="Account Verified" />
        <Stack direction="row" spacing={2} sx={{ margin: 'auto', width: '90%'}}>
        <FiberManualRecord sx={{ color: "primary.main" }} />
        <Typography>
        Your Registration has been verified.
        </Typography>
        </Stack>
        <Button variant="contained">Proceed</Button>
      </Stack>
    </Box>
  );
}
